import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import './App.css';
import AppRouter from './routes/AppRouter';
import CombinedProvider from './context/CombinedProvider';

function App() {
  
  return (
    <div className="h-full font-secondary">
      <CombinedProvider>
        <AppRouter />
        {/*@ts-ignore*/}
        <Toaster position="top-center" />
      </CombinedProvider>
    </div>
  );
}

export default App;
